import FloorSelect from "./FloorSelect/FloorSelect.js";
import Header from "../../../templates/src/Header/Header.js";
import Navigator from "../Navigator.js";
import FloorBubble from "./FloorBubble/FloorBubble.js";
import {gsap} from "gsap";
import FloorBuilding from "./FloorBuilding/FloorBuilding.js";
import App from "@templates/App/App.js";
import SpaceSelect from "@modules/navigator/Space/SpaceSelect/SpaceSelect.js";
import NavigatorRouter from "@modules/navigator/Navigator.router.js";
import Popup from "@templates/Components/Popup/Popup.js";
import ContactFlats from "@modules/forms/Templates/ContactFlats/ContactFlats.js";
import Space from "@modules/navigator/Space/Space.js";

const Floor = {
    height: 0,
    data: [],
    number: null,
    colors: {
        available: null,
        reserved: null,
        sold: null
    },

    init() {
        this.el = $('[component="Floor"]');
        if (!this.el.length) return;

        this.floorPlan = this.el.find(".floorPlan");
        this.linkPrices = this.el.find(".priceListUrl");

        FloorSelect.init();
        // BackButton.init();
        FloorBubble.init();
        FloorBuilding.init();
    },

    prepare() {
        this.flats = this.floorPlan.find("svg").find('#areas path[id], #areas rect[id]');

        $.each(this.flats, (index, flat) => {
            const letter = $(flat).attr("id");
            const id = this.number + letter;
            const data = this.data.flats[id];

            if (!!!data) {
                $(flat).addClass("NAN");
                return;
            }

            if (Space.isAvailable(data)) {
                $(flat).addClass("available");
            }

            if (Space.isSold(data)) {
                $(flat).addClass("sold");
            } else if (Space.isReserved(data)) {
                $(flat).addClass("reserved");
            }

            if (Space.isInDev(data)) {
                $(flat).addClass("dev");
            }
        });

        this.bind();
    },

    bind() {
        // --- DESKTOP only ---
        if (App.isDesktop || App.isLandscape) {
            this.flats.mouseover((evt) => {
                this.onEnter(evt)
            });

            this.flats.mouseleave((evt) => {
                this.onLeave(evt)
            });

            this.flats.click((evt) => {
                this.onClick(evt)
            });
        }

        // --- MOBILE and TABLET ---
        if (!App.isDesktop || App.isPortrait) {
            this.flats.click((evt) => {
                this.onEnter(evt)
            });
        }

        this.el.find('button.close.floor').unbind('click').click((evt) => {
            NavigatorRouter.setFloor(null)
        })

        this.floorPlan.find(".tabs li").unbind('click').click((evt) => {
            this.switchFloor($(evt.currentTarget));
        })

        $(document).on('keydown.closeFloor', (e) => {
            if (e.key === 'Escape' && (NavigatorRouter.state.floor && !NavigatorRouter.state.space)) {
                NavigatorRouter.setFloor(null);
            }
        });
    },

    onClick(evt) {
        let id = $(evt.currentTarget).attr("id");
        id = this.number + id;

        NavigatorRouter.setSpace(id);
        FloorBubble.hide();
    },

    onEnter(evt) {
        const flat = $(evt.currentTarget);
        let id = flat.attr("id");
        id = this.number + id;
        FloorBubble.show(evt, flat, this.data.flats[id]);
    },

    onLeave() {
        FloorBubble.hide();
    },

    loadFloorPlan() {
        if (!Floor.data.image) {
            return;
        }

        const name = Floor.data.image.split('.')[0];
        const suffix = window.innerHeight > window.innerWidth ? '.vertical.svg' : '.svg';

        const xhr = new XMLHttpRequest;
        xhr.open('get', name + suffix + '?v=2', true);
        xhr.onreadystatechange = () => {
            if (xhr.readyState !== 4) return;
            let svg = xhr.responseXML.documentElement;
            svg = document.importNode(svg, true);
            this.afterLoad(svg)
        };
        xhr.send();
    },

    loadFloor() {
        const prefix = window.innerHeight > window.innerWidth ? 'vertical.' : '';

        $.ajax({
            type: 'POST',
            url: WEB_ROOT + '/modules/navigator/Floor/Floor.medical.async.php',
            data: {floor: Floor.data.number, prefix: prefix},
            dataType: "html",

            success: (response, textStatus, jqXHR) => {
                if (response) {
                   this.afterLoad(response);
                }
            },
            error: (jqXHR, textStatus, errorThrown) => {
                console.error('AJAX Error:', textStatus, errorThrown);
                console.log('Response Text:', jqXHR.responseText);
            }
        });
        this.afterLoad()
    },

    afterLoad(content) {
        const zoom = NavigatorRouter.state.building === 'residence' ? 0.2 : 0.1;
        const _old = this.floorPlan.find('.holder');
        const _new = $('<div class="holder"/>');

        _new.append($(content))
            .appendTo(this.floorPlan);

        if (Floor.data.image) {
            const namePng = Floor.data.image.split('.')[0];
            const suffixPng = window.innerHeight > window.innerWidth ? '.vertical.png' : '.png';

            const png = $('<img class="planBg"/>');
            png.attr("src", namePng+suffixPng+'?v=2');

            _new.append(png)
                .appendTo(this.floorPlan);
        }

        Popup.initOpener(_new);
        ContactFlats.init();


        gsap.set(_old, {position: 'absolute'})
        gsap.set(_new, {opacity: 0, position: 'absolute'})

        gsap.timeline()
            .to(_old, {
                    scale: 1 - (-this.direction * zoom), filter: "blur(3px)", opacity: 0, duration: 0.7, ease: "power2.out", overwrite: true,
                    onComplete: () => {
                        _old.remove();
                        setTimeout(() => {
                            Floor.resize();
                            Navigator.setHeight();
                        }, 100)
                    }
                }, 0
            )
            .fromTo(_new, {
                    scale: 1 - (+this.direction * zoom), filter: "blur(3px)", opacity: 0
                }, {
                    scale: 1, opacity: 1, position: 'relative', filter: "blur(0px)", duration: 1, ease: "power2.out", overwrite: true, clearProps: 'all'
                }, 0.2
            )

        this.prepare();
    },

    switchFloor(el) {
        if(el.hasClass('active')) return;
        const id = el.attr("id");
        el.addClass("active").siblings().removeClass("active");

        const _old = this.floorPlan.find('.variant.active').removeClass('active');
        const _new = this.floorPlan.find('.variant[id="' + id + '"]').addClass('active');

        gsap.set(_old, {position: 'absolute'});
        gsap.set(_new, {display:'flex', opacity: 0, position: 'relative'});

        gsap.timeline()
            .to(_old, {
                    opacity: 0, display:'none', duration: 0.7, ease: "power2.out", overwrite: true,
                    onComplete: () => {
                        setTimeout(() => {
                            Floor.resize();
                            Navigator.setHeight();
                        }, 100)
                    }
                }, 0
            )
            .fromTo(_new, {
                    opacity: 0, display: 'none'
                }, {
                    opacity: 1, display: 'flex', duration: 0.5, ease: "power2.out", overwrite: true
                }, 0
            )
    },

    updatePriceListUrl() {
        let href = $(this.linkPrices).attr("href");
        href = href.replaceAll("X", this.data.number);
        $(this.linkPrices).attr("href", href);
    },

    show(data, dir = 0) {
        if (this.number === this.data.number) return;
        this.data = data;
        this.number = this.data.number;
        this.direction = dir;

        if (NavigatorRouter.state.building === 'residence') {
            this.loadFloorPlan();
            this.updatePriceListUrl();
        } else if (NavigatorRouter.state.building === 'medical') {
            this.loadFloor();
        }

        FloorBuilding.setActive(this.number);
        FloorSelect.update(this.number);

        this.el.addClass('show');
        Header.el.addClass('navigator');
    },

    hide() {
        this.number = null;
        this.el.removeClass('show');
        Header.el.removeClass('navigator');
    },

    resize() {
        if (this.debug) console.log('resize', this.el.find('[container]').outerHeight())
        this.height = this.el.find('main.floor').outerHeight() + 64;
        this.el.css({height: this.height});
    }
}

export default Floor;